import React from 'react';

const LinkElement = (props) => {
  if (props.link !== "") {
    return (
      <a className={props.add_class} href={props.link}>
        {props.children}
      </a>
    );
  } else {
    return (
      <div className={props.add_class}>
        {props.children}
      </div>
    );
  }
}

export default LinkElement;
